import { createContext, useContext } from 'react'

export const PortalRoot = createContext<HTMLElement | null>(null)

export function usePortalRoot(): HTMLElement {
  return useContext(PortalRoot) ?? document.body
}
